import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as THREE from 'three';

import HotspotVisual from '../visuals/HotspotVisual.jsx';
import InteractableObject from '../interactions/InteractableObject.jsx';
import { getThreeTransformFromArray } from '../../utils/ThreeTransformConverter.js';
import { setCursorStyle } from '../../utils/MouseUtilities.js';

const hoverCursorStyle = 'pointer';
const unhoverCursorStyle = 'all-scroll';

const isColliderVisible = false;

const spriteScale = new THREE.Vector3(1, 0.6, 1);

class Marker extends Component {
    constructor(props) {
        super(props);
        this.onHover = this.onHover.bind(this);
        this.onUnhover = this.onUnhover.bind(this);
        this.onClick = this.onClick.bind(this);

        this.transform = getThreeTransformFromArray(props.transform);
        this.colliderTransform = getThreeTransformFromArray(props.colliderTransform);
        this.mounted = false;
        this.state = {
            isHovered: false
        };
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    onHover() {
        if (this.props.onClick || this.props.onHover) {
            setCursorStyle(hoverCursorStyle);
            if (!this.mounted) {
                return;
            }
            if (this.props.onHover) {
                this.props.onHover();
            }
            this.setState({
                isHovered: true
            });
        }
    }

    onUnhover() {
        if (this.props.onClick || this.props.onUnhover) {
            setCursorStyle(unhoverCursorStyle);
            if (!this.mounted) {
                return;
            }
            if (this.props.onUnhover) {
                this.props.onUnhover();
            }
            this.setState({
                isHovered: false
            });
        }
    }

    onClick() {
        if (this.props.onClick) {
            this.props.onClick();
        }
    }

    render() {
        const { fade, normalSpriteUrl, hoveredSpriteUrl, svgSprite, svgSpriteString, rotationAngle, primaryColor, secondaryColor, isLabel } = this.props;
         
        const hostSpotVisual = this.props.showVisual
            ? <HotspotVisual
                transform={this.transform}
                isHovered={this.state.isHovered}
                spriteScale={spriteScale}
                normalSpriteUrl={normalSpriteUrl}
                hoveredSpriteUrl={hoveredSpriteUrl}
                svgSprite={svgSprite}
                type={this.props.type}
                svgSpriteString={svgSpriteString}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                rotationAngle={rotationAngle}
                fade={fade}
                isLabel={isLabel}
            /> : <div />

        return (
            <div>
                {hostSpotVisual}
                <InteractableObject
                    colliderTransform={this.colliderTransform}
                    isColliderVisible={isColliderVisible}
                    isLookingCenter={true}
                    onHover={this.onHover}
                    onUnhover={this.onUnhover}
                    onClick={this.onClick}
                />
            </div>
        );
    }
}

Marker.propTypes = {
    transform: PropTypes.array,
    colliderTransform: PropTypes.array,
    normalSpriteUrl: PropTypes.string,
    hoveredSpriteUrl: PropTypes.string,
    svgSprite: PropTypes.func,
    svgSpriteString: PropTypes.string,
    showVisual: PropTypes.bool,
    onHover: PropTypes.func,
    onUnhover: PropTypes.func,
    onClick: PropTypes.func,
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    rotationAngle: PropTypes.number,
    fade: PropTypes.bool,
    isLabel: PropTypes.bool
};

export default Marker;